import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { RadioProvider } from "./contexts/RadioContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import AppShell from "./components/AppShell";

// Public pages
import Home from "./pages/Home";
import Explore from "./pages/Explore";
import Radio from "./pages/Radio";
import StationPage from "./pages/StationPage";
import CreatorProfile from "./pages/CreatorProfile";
import ContentPage from "./pages/ContentPage";
import Live from "./pages/Live";
import Auth from "./pages/Auth";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import NotFound from "./pages/NotFound";

import Apply from "./pages/Apply";

// Dashboard
import Dashboard, { DashboardHome } from "./pages/dashboard/Dashboard";
import DashboardProfile from "./pages/dashboard/Profile";
import DashboardUpload from "./pages/dashboard/Upload";
import DashboardShows from "./pages/dashboard/Shows";
import DashboardStation from "./pages/dashboard/Station";
import DashboardContent from "./pages/dashboard/Content";
import DashboardAutoDJ from "./pages/dashboard/AutoDJ";
import DashboardLive from "./pages/dashboard/LiveStream";

// Admin
import Admin from "./pages/admin/Admin";
import AdminCreators from "./pages/admin/Creators";
import AdminStations from "./pages/admin/Stations";
import AdminShows from "./pages/admin/Shows";
import AdminContent from "./pages/admin/Content";
import AdminFeatured from "./pages/admin/Featured";
import AdminSiteSettings from "./pages/admin/SiteSettings";
import AdminMonitoring from "./pages/admin/Monitoring";

function App() {
  return (
    <AuthProvider>
      <RadioProvider>
        <BrowserRouter>
          <AppShell>
            <Routes>
              {/* Public */}
              <Route path="/" element={<Home />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/radio" element={<Radio />} />
              <Route path="/radio/:stationId" element={<StationPage />} />
              <Route path="/c/:slug" element={<CreatorProfile />} />
              <Route path="/content/:contentId" element={<ContentPage />} />
              <Route path="/live" element={<Live />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />

              {/* Creator Dashboard — nested routes so sub-nav always shows */}
              <Route path="/dashboard" element={<ProtectedRoute requireRole="creator"><Dashboard /></ProtectedRoute>}>
                <Route index element={<DashboardHome />} />
                <Route path="profile" element={<DashboardProfile />} />
                <Route path="upload" element={<DashboardUpload />} />
                <Route path="shows" element={<DashboardShows />} />
                <Route path="station" element={<DashboardStation />} />
                <Route path="content" element={<DashboardContent />} />
                <Route path="autodj" element={<DashboardAutoDJ />} />
                <Route path="live" element={<DashboardLive />} />
              </Route>

              {/* Admin - only accessible to stagepassadmin@gmail.com */}
              <Route path="/admin" element={<ProtectedRoute requireRole="admin"><Admin /></ProtectedRoute>} />
              <Route path="/admin/creators" element={<ProtectedRoute requireRole="admin"><AdminCreators /></ProtectedRoute>} />
              <Route path="/admin/stations" element={<ProtectedRoute requireRole="admin"><AdminStations /></ProtectedRoute>} />
              <Route path="/admin/shows" element={<ProtectedRoute requireRole="admin"><AdminShows /></ProtectedRoute>} />
              <Route path="/admin/content" element={<ProtectedRoute requireRole="admin"><AdminContent /></ProtectedRoute>} />
              <Route path="/admin/featured" element={<ProtectedRoute requireRole="admin"><AdminFeatured /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute requireRole="admin"><AdminSiteSettings /></ProtectedRoute>} />
              <Route path="/admin/monitoring" element={<ProtectedRoute requireRole="admin"><AdminMonitoring /></ProtectedRoute>} />

              <Route path="*" element={<NotFound />} />
            </Routes>
          </AppShell>
        </BrowserRouter>
      </RadioProvider>
    </AuthProvider>
  );
}

export default App;
